import React from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

// Breadcrumb trail for the Training Overview drill-down (Company › Store ›
// Employee). Replaces the old persistent top bar: navigation lives inline.
// Each crumb except the last is a clickable button that jumps straight to that
// level; the last crumb is the current location and is rendered as plain text.
//
// crumbs: [{ label: string, onClick?: () => void }]
function TrainingBreadcrumb({ crumbs = [] }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className="flex items-center gap-1 text-sm"
    >
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;
        const isClickable = !isLast && typeof crumb.onClick === "function";
        return (
          <React.Fragment key={`${crumb.label}-${index}`}>
            {index > 0 && (
              <ChevronRightIcon
                className="shrink-0 text-slate-300"
                style={{ fontSize: "18px" }}
              />
            )}
            {isClickable ? (
              <button
                type="button"
                onClick={crumb.onClick}
                className="rounded font-medium text-slate-500 transition-colors hover:text-violet-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-200"
              >
                {crumb.label}
              </button>
            ) : (
              <span
                aria-current={isLast ? "page" : undefined}
                className={
                  isLast
                    ? "font-semibold text-slate-900"
                    : "font-medium text-slate-500"
                }
              >
                {crumb.label}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

export default TrainingBreadcrumb;
